import { render, staticRenderFns } from "./WeeklyStat.vue?vue&type=template&id=d5b920c6&"
import script from "./WeeklyStat.vue?vue&type=script&lang=js&"
export * from "./WeeklyStat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports